/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClientsById: build.query<
      GetClientsByIdApiResponse,
      GetClientsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/client/Clients/${queryArg.id}` }),
    }),
    getClientsQuery: build.query<
      GetClientsQueryApiResponse,
      GetClientsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/Clients/query`,
        params: {
          clientNo: queryArg.clientNo,
        },
      }),
    }),
    getClients: build.query<GetClientsApiResponse, GetClientsApiArg>({
      query: () => ({ url: `/client/Clients` }),
    }),
    getClientsByIdDocuments: build.query<
      GetClientsByIdDocumentsApiResponse,
      GetClientsByIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.id}/documents`,
        params: {
          isBoardPortal: queryArg.isBoardPortal,
        },
      }),
    }),
    getClientsByIdDocumentsAndDocumentIdDownload: build.query<
      GetClientsByIdDocumentsAndDocumentIdDownloadApiResponse,
      GetClientsByIdDocumentsAndDocumentIdDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.id}/documents/${queryArg.documentId}/download`,
        params: {
          isBoardPortal: queryArg.isBoardPortal,
        },
      }),
    }),
    getClientsByIdPrivacystatement: build.query<
      GetClientsByIdPrivacystatementApiResponse,
      GetClientsByIdPrivacystatementApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.id}/privacystatement`,
      }),
    }),
    getClientsByIdSettings: build.query<
      GetClientsByIdSettingsApiResponse,
      GetClientsByIdSettingsApiArg
    >({
      query: (queryArg) => ({ url: `/client/Clients/${queryArg.id}/settings` }),
    }),
    postPortalusers: build.mutation<
      PostPortalusersApiResponse,
      PostPortalusersApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/portalusers`,
        method: 'POST',
        body: queryArg.portalUserQueryModel,
      }),
    }),
    getPortalusersSummary: build.query<
      GetPortalusersSummaryApiResponse,
      GetPortalusersSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/portalusers/summary`,
      }),
    }),
    putContactsAndNameId: build.mutation<
      PutContactsAndNameIdApiResponse,
      PutContactsAndNameIdApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/contacts/${queryArg.nameId}`,
        method: 'PUT',
        body: queryArg.updateContactModel,
      }),
    }),
    getContactsAndNameIdUnits: build.query<
      GetContactsAndNameIdUnitsApiResponse,
      GetContactsAndNameIdUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/contacts/${queryArg.nameId}/units`,
      }),
    }),
    postContactsQuery: build.mutation<
      PostContactsQueryApiResponse,
      PostContactsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/contacts/query`,
        method: 'POST',
        body: queryArg.contactsQueryModel,
      }),
    }),
    postOthercontactsQuery: build.mutation<
      PostOthercontactsQueryApiResponse,
      PostOthercontactsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/othercontacts/query`,
        method: 'POST',
        body: queryArg.otherContactsQueryModel,
      }),
    }),
    postBoardcontactsQuery: build.mutation<
      PostBoardcontactsQueryApiResponse,
      PostBoardcontactsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/boardcontacts/query`,
        method: 'POST',
        body: queryArg.boardContactsQueryModel,
      }),
    }),
    getBoardcontactsAndId: build.query<
      GetBoardcontactsAndIdApiResponse,
      GetBoardcontactsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/boardcontacts/${queryArg.id}`,
      }),
    }),
    putBoardcontactsAndId: build.mutation<
      PutBoardcontactsAndIdApiResponse,
      PutBoardcontactsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/boardcontacts/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.boardContactsUpdateModel,
      }),
    }),
    deleteBoardcontactsAndId: build.mutation<
      DeleteBoardcontactsAndIdApiResponse,
      DeleteBoardcontactsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/boardcontacts/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    postBoardcontacts: build.mutation<
      PostBoardcontactsApiResponse,
      PostBoardcontactsApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/boardcontacts`,
        method: 'POST',
        body: queryArg.boardContactsUpdateModel,
      }),
    }),
    postObjectcontactsQuery: build.mutation<
      PostObjectcontactsQueryApiResponse,
      PostObjectcontactsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/objectcontacts/query`,
        method: 'POST',
        body: queryArg.objectContactQueryModel,
      }),
    }),
    postMetercontactsQuery: build.mutation<
      PostMetercontactsQueryApiResponse,
      PostMetercontactsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/metercontacts/query`,
        method: 'POST',
        body: queryArg.meterContactQueryModel,
      }),
    }),
    getObjecttypes: build.query<
      GetObjecttypesApiResponse,
      GetObjecttypesApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/objecttypes`,
        params: {
          filterOption: queryArg.filterOption,
        },
      }),
    }),
    getMetertypes: build.query<GetMetertypesApiResponse, GetMetertypesApiArg>({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/metertypes`,
        params: {
          filterOption: queryArg.filterOption,
        },
      }),
    }),
    getClientsByClientNoActiveinfo: build.query<
      GetClientsByClientNoActiveinfoApiResponse,
      GetClientsByClientNoActiveinfoApiArg
    >({
      query: (queryArg) => ({
        url: `/client/Clients/${queryArg.clientNo}/activeinfo`,
      }),
    }),
    putClientsByIdAdvisorportalaccess: build.mutation<
      PutClientsByIdAdvisorportalaccessApiResponse,
      PutClientsByIdAdvisorportalaccessApiArg
    >({
      query: (queryArg) => ({
        url: `/client/Clients/${queryArg.id}/advisorportalaccess`,
        method: 'PUT',
        body: queryArg.portalAdvisorUpdateModel,
      }),
    }),
    getClientsByClientNoOwners: build.query<
      GetClientsByClientNoOwnersApiResponse,
      GetClientsByClientNoOwnersApiArg
    >({
      query: (queryArg) => ({
        url: `/client/Clients/${queryArg.clientNo}/owners`,
      }),
    }),
    getMinimizedClients: build.query<
      GetMinimizedClientsApiResponse,
      GetMinimizedClientsApiArg
    >({
      query: (queryArg) => ({
        url: `/client/MinimizedClients`,
        params: {
          Ids: queryArg.ids,
          SortOrder: queryArg.sortOrder,
          SortColumn: queryArg.sortColumn,
        },
      }),
    }),
    getBblcontacts: build.query<
      GetBblcontactsApiResponse,
      GetBblcontactsApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/bblcontacts`,
      }),
    }),
    putContactsAndNameIdElectroniccommunication: build.mutation<
      PutContactsAndNameIdElectroniccommunicationApiResponse,
      PutContactsAndNameIdElectroniccommunicationApiArg
    >({
      query: (queryArg) => ({
        url: `/client/clients/${queryArg.clientId ?? ':clientId'}/contacts/${queryArg.nameId}/electroniccommunication`,
        method: 'PUT',
        body: queryArg.updateElectronicCommunicationModel,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as client }
export type GetClientsByIdApiResponse = /** status 200 OK */ Client
export type GetClientsByIdApiArg = {
  id: string
}
export type GetClientsQueryApiResponse = /** status 200 OK */ Client
export type GetClientsQueryApiArg = {
  clientNo?: number
}
export type GetClientsApiResponse = /** status 200 OK */ Client[]
export type GetClientsApiArg = void
export type GetClientsByIdDocumentsApiResponse =
  /** status 200 OK */ ClientDocumentModel[]
export type GetClientsByIdDocumentsApiArg = {
  /** client id */
  id: string
  /** False (default) for My page applications, true if board portal application */
  isBoardPortal?: boolean
}
export type GetClientsByIdDocumentsAndDocumentIdDownloadApiResponse =
  /** status 200 OK */ Blob
export type GetClientsByIdDocumentsAndDocumentIdDownloadApiArg = {
  /** client id */
  id: string
  /** document id */
  documentId: string
  /** False (default) for My page applications, true if board portal application */
  isBoardPortal?: boolean
}
export type GetClientsByIdPrivacystatementApiResponse =
  /** status 200 OK */ PrivacyStatement
export type GetClientsByIdPrivacystatementApiArg = {
  /** client id */
  id: string
}
export type GetClientsByIdSettingsApiResponse =
  /** status 200 OK */ ClientSettings
export type GetClientsByIdSettingsApiArg = {
  /** clientId */
  id: string
}
export type PostPortalusersApiResponse =
  /** status 200 OK */ PortalUsersQueryResultRead
export type PostPortalusersApiArg = {
  clientId?: string
  portalUserQueryModel: PortalUserQueryModel
}
export type GetPortalusersSummaryApiResponse =
  /** status 200 OK */ PortalUserSummary
export type GetPortalusersSummaryApiArg = {
  clientId?: string
}
export type PutContactsAndNameIdApiResponse = unknown
export type PutContactsAndNameIdApiArg = {
  /** Client context */
  clientId?: string
  /** Id of user to be updated */
  nameId: string
  /** Data to be updated */
  updateContactModel: UpdateContactModel
}
export type GetContactsAndNameIdUnitsApiResponse =
  /** status 200 OK */ ContactUnitModel[]
export type GetContactsAndNameIdUnitsApiArg = {
  /** Client context */
  clientId?: string
  nameId: string
}
export type PostContactsQueryApiResponse =
  /** status 200 OK */ ContactModelContactsQueryResultRead
export type PostContactsQueryApiArg = {
  /** Client context */
  clientId?: string
  contactsQueryModel: ContactsQueryModel
}
export type PostOthercontactsQueryApiResponse =
  /** status 200 OK */ OtherContactsQueryResultRead
export type PostOthercontactsQueryApiArg = {
  /** Client context */
  clientId?: string
  otherContactsQueryModel: OtherContactsQueryModel
}
export type PostBoardcontactsQueryApiResponse =
  /** status 200 OK */ BoardContactsQueryResultRead
export type PostBoardcontactsQueryApiArg = {
  /** Client context */
  clientId?: string
  boardContactsQueryModel: BoardContactsQueryModel
}
export type GetBoardcontactsAndIdApiResponse =
  /** status 200 OK */ BoardContactsModel
export type GetBoardcontactsAndIdApiArg = {
  /** Client context */
  clientId?: string
  id: number
}
export type PutBoardcontactsAndIdApiResponse = unknown
export type PutBoardcontactsAndIdApiArg = {
  /** Client context */
  clientId?: string
  id: number
  boardContactsUpdateModel: BoardContactsUpdateModel
}
export type DeleteBoardcontactsAndIdApiResponse = unknown
export type DeleteBoardcontactsAndIdApiArg = {
  /** Client context */
  clientId?: string
  id: number
}
export type PostBoardcontactsApiResponse = /** status 200 OK */ number
export type PostBoardcontactsApiArg = {
  /** Client context */
  clientId?: string
  boardContactsUpdateModel: BoardContactsUpdateModel
}
export type PostObjectcontactsQueryApiResponse =
  /** status 200 OK */ ObjectContactModelContactsQueryResultRead
export type PostObjectcontactsQueryApiArg = {
  /** Client context */
  clientId?: string
  objectContactQueryModel: ObjectContactQueryModel
}
export type PostMetercontactsQueryApiResponse =
  /** status 200 OK */ ObjectContactModelContactsQueryResultRead
export type PostMetercontactsQueryApiArg = {
  /** Client context */
  clientId?: string
  meterContactQueryModel: MeterContactQueryModel
}
export type GetObjecttypesApiResponse = /** status 200 OK */ ClientObjectType[]
export type GetObjecttypesApiArg = {
  /** Client context */
  clientId?: string
  /** Optional filter option. Use 0 (default) for no filtering. */
  filterOption?: TypeFilterOption
}
export type GetMetertypesApiResponse = /** status 200 OK */ ClientMeterType[]
export type GetMetertypesApiArg = {
  /** Client context */
  clientId?: string
  /** Optional filter option. Use 0 (default) for no filtering. */
  filterOption?: TypeFilterOption
}
export type GetClientsByClientNoActiveinfoApiResponse =
  /** status 200 OK */ ClientActiveInfoModel
export type GetClientsByClientNoActiveinfoApiArg = {
  /** clientNo */
  clientNo: number
}
export type PutClientsByIdAdvisorportalaccessApiResponse =
  /** status 200 OK */ string
export type PutClientsByIdAdvisorportalaccessApiArg = {
  id: string
  portalAdvisorUpdateModel: PortalAdvisorUpdateModel
}
export type GetClientsByClientNoOwnersApiResponse =
  /** status 200 OK */ string[]
export type GetClientsByClientNoOwnersApiArg = {
  /** clientNo */
  clientNo: number
}
export type GetMinimizedClientsApiResponse =
  /** status 200 OK */ ClientMinimized[]
export type GetMinimizedClientsApiArg = {
  /** Optional list of client ids to get
    <i>Valgfri liste med forvaltningsklient-id-er</i> */
  ids?: string[]
  /** Descending or Ascending. Defaults to Ascending. */
  sortOrder?: SortOrder
  /** Sort by column No (client number) or Name (client name). Defaults to No. */
  sortColumn?: MinimizedClientsSortColumn
}
export type GetBblcontactsApiResponse = /** status 200 OK */ BblContactModel[]
export type GetBblcontactsApiArg = {
  /** Client context */
  clientId?: string
}
export type PutContactsAndNameIdElectroniccommunicationApiResponse = unknown
export type PutContactsAndNameIdElectroniccommunicationApiArg = {
  /** Client context */
  clientId?: string
  /** Id of user to be updated */
  nameId: string
  /** Electronic communication data */
  updateElectronicCommunicationModel: UpdateElectronicCommunicationModel
}
export type ClientType = {
  /** Client type code
    <i>Typekode</i> */
  code?: string | null
  /** Description
    <i>Beskrivelse</i> */
  description?: string | null
  /** Company type code
    <i>Selskapstypekode</i> */
  companyTypeCode?: string | null
  /** Affiliated
    <i>Tilknyttet</i> */
  affiliated?: boolean
}
export type CompanyType = {
  /** Company type code */
  code?: string | null
  /** Description */
  description?: string | null
  /** True if the company is a borettslag */
  borettslag?: boolean
  /** True if the company is a aksjeselskap */
  aksjeselskap?: boolean
  /** True if the company is a andellag */
  andelslag?: boolean
  /** True if the company is a sameie */
  sameie?: boolean
  /** True if the company is a stiftelse */
  stiftelse?: boolean
  eiere?: boolean
  /** Code of the organisasjonsform (SA, BRL, etc) */
  organisasjonsform?: string | null
}
export type ClientExtendedInformation = {
  /** Id of the extended information */
  id?: string | null
  /** Name of the extended information */
  text?: string | null
  /** Sort order of the extended information */
  sort?: number
}
export type Client = {
  /** Unique identifier for client
    <i>Unik id forvaltningsklient</i> */
  id?: string | null
  /** Client number
    <i>Klient Nr</i> */
  clientNo?: number
  /** Client name
    <i>KlientNavn</i> */
  clientName?: string | null
  clientType?: ClientType
  companyType?: CompanyType
  /** Company number (Organization number)
    <i>Organisasjonsnummer</i> */
  companyNumber?: string | null
  /** Date of last change in foretakreg
    <i>Dato sist endring i foretakreg</i> */
  lastChangeForetakReg?: string | null
  /** Date of foundation
    <i>Dato stiftet</i> */
  foundedDate?: string | null
  /** Client nr of the main client(connected client)
    <i>Nr Hovedklient</i> */
  mainClient?: number | null
  /** JointDebt
    <i>Fellesgjeld</i> */
  jointDebt?: number | null
  /** If the client is in the norwegian mva register
    <i>MVA</i> */
  vatEligible?: boolean
  /** The business address of the client
    <i>Forretningsadresse</i> */
  businessAddress?: string | null
  /** The business postal code of the client
    <i>Forretningsadresse</i> */
  businessZip?: string | null
  /** The business city of the client
    <i>Forretningsadresse</i> */
  businessCity?: string | null
  /** Business country of the client */
  businessCountry?: string | null
  /** Business country code of the client */
  businessCountryCode?: string | null
  /** Invoice address for the client
    <i>Fakturaadresse</i> */
  invoiceAddress?: string | null
  /** Invoice zip for the client
    <i>Fakturaadresse</i> */
  invoiceZip?: string | null
  /** Invoice city for the client
    <i>Fakturaadresse</i> */
  invoiceCity?: string | null
  /** Invoice country for the client */
  invoiceCountry?: string | null
  /** Invoice country code for the client */
  invoiceCountryCode?: string | null
  /** Postal code
    <i>Postkode</i> */
  postalCode?: string | null
  /** Country code
    <i>Landkode</i> */
  countryCode?: string | null
  /** Website
    <i>Webside</i> */
  website?: string | null
  /** Total insurance provider
    <i>Totalforsikringsleverandør</i> */
  totalInsuranceProviderId?: string | null
  /** Email of the client
    <i>E-post</i> */
  epost?: string | null
  /** True if an external url is used to view overdue invoices in the my page portal.
    The url is found in the house-building cooperation's setting Urls.FinanceInfocenter.
    *True hvis "Overfør finansieringsforetak" er aktivert i Hårfagre Classic* */
  hasFinanceInfocenter?: boolean
  /** <i>Siste vedtektsendring</i> */
  lastStatuteChangedDate?: string | null
  /** <i>Normal drift dato</i> */
  normalOperationsDate?: string | null
  /** Extended information about client */
  extendedInformation?: ClientExtendedInformation[] | null
  /** If board has allowed full access for advisors */
  advisorsGrantedFullAccessOnStyreportal?: boolean
  /** If client uses the light edition of applications */
  hasLightSystem?: boolean
  /** Accountant mail address */
  accountantMailAddress?: string | null
  /** Case worker mail address */
  caseWorkerMailAddress?: string | null
  /** Change of ownership caseworker mail address */
  changeOfOwnershipCaseWorkerMailAddress?: string | null
  /** Business number
    <i>Virksomhetsnummer</i> */
  businessNumber?: string | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type ClientDocumentModel = {
  title?: string | null
  documentId?: string | null
  documentTypeTitle?: string | null
  contentType?: string | null
  originalFilename?: string | null
  originalFileSuffix?: string | null
}
export type PrivacySection = {
  /** Title of section */
  title?: string | null
  /** Text content of section */
  text?: string | null
}
export type PrivacyStatement = {
  /** Client id of privacy statment */
  clientId?: string | null
  /** Title of the privacy statement */
  title?: string | null
  /** Sections of the privacy statement */
  sections?: PrivacySection[] | null
}
export type ClientSettings = {
  /** Client Id */
  id?: string | null
  /** All available portal tilgjengelig entries for given client */
  portalAvailableIds?: string[] | null
}
export type UnitIdentification = {
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit (*Seksjonsnummer*) */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit(*Andelsnummer*) */
  propertySectionNo?: string | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number
  /** Property shared number(*Aksjeboenhetsnummer*) */
  propertySharedNo?: string | null
}
export type PortalUserModel = {
  /** Nameregister id
    <remarks>Navneregisterid</remarks> */
  nameregisterId?: string | null
  /** True if given user is proxy owner
    <remarks>Er fullmaktshaver</remarks> */
  isProxyOwner?: boolean
  /** True if given user is owner
    <remarks>Er eier</remarks> */
  isOwner?: boolean
  /** True if given user is tenant
    <remarks>Er leietaker</remarks> */
  isTenant?: boolean
  /** True if given user is resident
    <remarks>Er medboer</remarks> */
  isCoResident?: boolean
  /** Address of unit
    <remarks>Enhetsaddresse</remarks> */
  address?: string | null
  unitIdentificationFields?: UnitIdentification
  /** If user has reserved against electronic communication - date of reservation
    <remarks>Dato for reservert mot elektronisk kommunikasjon</remarks> */
  reservedAgainstElectronicCommunication?: string | null
  /** True if given user has never signed in to BBLiD
    <remarks>Bruker har ikke logget inn i BBLiD</remarks> */
  hasSignedIn?: boolean
  /** Full name of user
    <remarks>Fullt navn</remarks> */
  name?: string | null
  /** User email address */
  email?: string | null
  /** User mobilenumber */
  mobile?: string | null
}
export type PortalUsersQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: PortalUserModel[] | null
}
export type PortalUsersQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: PortalUserModel[] | null
}
export type PortalUserQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  sortColumn?: PortalUserSortColumn
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  portalUserRole?: PortalUserQueryRoles
}
export type PortalUserSummary = {
  /** Signed in owners count */
  ownersCount?: number
  /** Signed in tenants count */
  tenantsCount?: number
  /** Signed in co residents count */
  coResidentsCount?: number
  /** Signed in proxy owner count */
  proxyOwnerCount?: number
  /** Count of users connected to the client who has not signed in. */
  notSignedInCount?: number
  /** Count of users that are reserverd against electronic communication */
  reservedAgainstElectronicCommunicationCount?: number
}
export type UpdateContactModel = {
  /** Phonenumber.
    Must be a valid phonenumber */
  phonenumber?: string | null
  /** Email.
    Must be a valid email */
  email?: string | null
}
export type ContactUnitModel = {
  /** Address of unit
    <remarks>Enhetsaddresse</remarks> */
  address?: string | null
  unitIdentificationFields?: UnitIdentification
  role?: ContactRole
  /** Descriptive role, role name but if  proxy owner it gives the name the user is proxy owner for */
  roleDescription?: string | null
}
export type UnitInfo = {
  /** Address id of unit */
  addressId?: number | null
  /** Building type index number */
  buildingTypeIndexNo?: number | null
  /** Address of the unit */
  address?: string | null
  /** Building type where unit is located */
  buildingType?: string | null
  unitIdentification?: UnitIdentification
  role?: ContactRole
  /** Norwegian role name: Eier (owner), Leietaker (tenant) or Fullmaktshaver (proxy holder) */
  roleDescription?: string | null
  /** Id of unit */
  unitId?: string | null
  /** Name of the building where the unit is located */
  buildingName?: string | null
  /** Id of the building where the unit is located */
  buildingId?: number | null
}
export type ContactModel = {
  /** Nameregister id
    <remarks>Navneregisterid</remarks> */
  nameregisterId?: string | null
  /** Full name of user
    <remarks>Fullt navn</remarks> */
  name?: string | null
  /** User email address */
  email?: string | null
  /** User mobilenumber */
  mobile?: string | null
  /** If user has reserved against electronic communication - date of reservation
    <remarks>Dato for reservert mot elektronisk kommunikasjon</remarks> */
  reservedAgainstElectronicCommunication?: string | null
  /** True if given user has signed in to BBLiD
    <remarks>Bruker har logget inn i BBLiD</remarks> */
  hasSignedIn?: boolean
  /** If query specifies extended info, this property will include unit info for units connected to contact. */
  unitInfo?: UnitInfo[] | null
  role?: ContactRole
  /** Norwegian role name: Eier (owner), Leietaker (tenant) or Fullmaktshaver (proxy holder) */
  roleDescription?: string | null
}
export type ContactModelContactsQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: ContactModel[] | null
}
export type ContactModelContactsQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: ContactModel[] | null
}
export type ContactsQueryModel = {
  sortorder?: SortOrder
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  clientId?: string | null
  sortColumn?: ContactSortColumn
  contactRole?: ContactQueryRoles
  extendedQueryType?: ExtendedQueryType
  /** Combine with extended query type to query contacts by address id
    <remarks>Byningsadresseindxnr</remarks> */
  addressId?: number | null
  /** Combine with extended query type to query contacts by building id */
  buildingId?: number | null
  /** Combine with extended query type to query contacts by buildingtype id
    <remarks>Bygningstypeid</remarks> */
  buildingTypeId?: number | null
}
export type AddressModel = {
  /** Street adress line 1
    <i>Adresselinje1</i> */
  line1?: string | null
  /** Street adress line 2
    <i>Adresselinje2</i> */
  line2?: string | null
  /** Street adress line 3
    <i>Adresselinje3</i> */
  line3?: string | null
  /** Zip code
    <i>Postkode</i> */
  zip?: string | null
  /** City
    <i>By</i> */
  city?: string | null
  /** Country */
  country?: string | null
  /** Country code */
  countryCode?: string | null
}
export type OtherContactsModel = {
  /** Nameregister id
    <remarks>Navneregisterid</remarks> */
  nameregisterId?: string | null
  /** User mobilenumber */
  companyName?: string | null
  /** User mobilenumber */
  position?: string | null
  /** Full name of user
    <remarks>Fullt navn</remarks> */
  name?: string | null
  /** User email address */
  email?: string | null
  /** User mobilenumber */
  mobile?: string | null
  /** Work phone */
  workPhoneNumber?: string | null
  /** Work e-mail */
  workEmail?: string | null
  address?: AddressModel
}
export type OtherContactsQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: OtherContactsModel[] | null
}
export type OtherContactsQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: OtherContactsModel[] | null
}
export type OtherContactsQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  sortColumn?: OtherContactsSortColumn
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
}
export type BoardContactsModel = {
  /** Last name of the contact. */
  lastname?: string | null
  /** First name of the contact. */
  firstname?: string | null
  /** Email address of the contact. */
  email?: string | null
  /** Phone number of the contact. */
  phone?: string | null
  /** Fax number of the contact. */
  fax?: string | null
  /** Zip code of the contact's address. */
  zipCode?: string | null
  /** Country code of the contact's address. */
  countryCode?: string | null
  /** City of the contact's address. */
  city?: string | null
  /** First address line. */
  adressline1?: string | null
  /** Second address line. */
  adressline2?: string | null
  /** Third address line. */
  adressline3?: string | null
  /** Additional notes for the contact. */
  notes?: string | null
  /** Company name associated with the contact. */
  companyName?: string | null
  /** Department of the contact within the company. */
  department?: string | null
  /** Position or job title of the contact. */
  position?: string | null
  /** Mobile phone number of the contact. */
  mobile?: string | null
  /** Web address associated with the contact. */
  webAdress?: string | null
  /** Organization number for the company. */
  organizationNumber?: string | null
  /** Indicates whether the contact is a company. */
  isCompany?: boolean
  /** Unique identifier for the board contact.
    <remarks>EgneKontakter.Id</remarks> */
  id?: number
  /** Full name of the board contact. */
  fullname?: string | null
  /** Country name of the board contact. */
  country?: string | null
}
export type BoardContactsQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: BoardContactsModel[] | null
}
export type BoardContactsQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: BoardContactsModel[] | null
}
export type BoardContactsQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortorder?: SortOrder
  sortColumn?: BoardContactsSortColumn
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
}
export type BoardContactsUpdateModel = {
  /** Last name of the contact. */
  lastname?: string | null
  /** First name of the contact. */
  firstname?: string | null
  /** Email address of the contact. */
  email?: string | null
  /** Phone number of the contact. */
  phone?: string | null
  /** Fax number of the contact. */
  fax?: string | null
  /** Zip code of the contact's address. */
  zipCode?: string | null
  /** Country code of the contact's address. */
  countryCode?: string | null
  /** City of the contact's address. */
  city?: string | null
  /** First address line. */
  adressline1?: string | null
  /** Second address line. */
  adressline2?: string | null
  /** Third address line. */
  adressline3?: string | null
  /** Additional notes for the contact. */
  notes?: string | null
  /** Company name associated with the contact. */
  companyName?: string | null
  /** Department of the contact within the company. */
  department?: string | null
  /** Position or job title of the contact. */
  position?: string | null
  /** Mobile phone number of the contact. */
  mobile?: string | null
  /** Web address associated with the contact. */
  webAdress?: string | null
  /** Organization number for the company. */
  organizationNumber?: string | null
  /** Indicates whether the contact is a company. */
  isCompany?: boolean
}
export type ItemModel = {
  /** Objektindexnr or Maalerindexnr */
  id?: number
  /** Name of objekt/maaler */
  name?: string | null
}
export type ObjectContactModel = {
  /** Fullname of contact */
  name?: string | null
  /** Email for contact */
  email?: string | null
  /** Mobile number for contact */
  mobile?: string | null
  /** Object type name */
  objectType?: string | null
  /** List of all objects of given object type that the contact has a relation to */
  objects?: ItemModel[] | null
  /** If user has reserved against electronic communication - date of reservation
    <remarks>Dato for reservert mot elektronisk kommunikasjon</remarks> */
  reservedAgainstElectronicCommunication?: string | null
  /** Navneregister id of contact */
  nameId?: string | null
  /** NameNo of contact */
  nameNo?: number
  /** Objecttype number */
  objecttypeNo?: number
  /** True if given user has signed in to BBLiD
    <remarks>Bruker har logget inn i BBLiD</remarks> */
  hasSignedIn?: boolean
}
export type ObjectContactModelContactsQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: ObjectContactModel[] | null
}
export type ObjectContactModelContactsQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: ObjectContactModel[] | null
}
export type ObjectContactQueryModel = {
  sortorder?: SortOrder
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  clientId?: string | null
  /** Object or Meter type no.
    <remarks></remarks> */
  objectTypeNo?: number
  sortColumn?: ItemContactSortColumn
}
export type MeterContactQueryModel = {
  sortorder?: SortOrder
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  clientId?: string | null
  /** Meter type no
    <remarks></remarks> */
  meterTypeNo?: number
  sortColumn?: ItemContactSortColumn
}
export type ClientObjectType = {
  /** Objecttype id */
  objectTypeId?: number
  /** Descriptive name of object type */
  objectType?: string | null
}
export type ClientMeterType = {
  /** Metertype id */
  meterTypeId?: number
  /** Descriptive name of meter type */
  meterType?: string | null
}
export type ClientActiveInfoModel = {
  /** Client Id */
  clientId?: string | null
  /** Client number */
  clientNo?: number
  /** Client name */
  clientName?: string | null
  /** True if client is active in HF */
  isActive?: boolean
  /** Company number (Organization number)
    <i>Organisasjonsnummer</i> */
  companyNumber?: string | null
  /** Client type
    Norsk: Selskapstype */
  clientType?: string | null
  /** Case manager id
    <i>NavneregisterId til saksbehandler</i> */
  caseManagerId?: string | null
  /** Accountant id
    <i>NavneregisterId til regnskapsfører</i> */
  accountantId?: string | null
  /** Case manager change of ownership id
    <i>NavneregisterId til saksbehandler eierskifte</i> */
  caseManagerChangeOfOwnershipId?: string | null
  /** Assignment manager id
    <i>NavneregisterId til oppdragsansvarlig</i> */
  assignmentManagerId?: string | null
}
export type PortalAdvisorUpdateModel = {
  /** Set to true to allow the portal advisor to access the portal. */
  allow?: boolean
}
export type ClientMinimized = {
  /** Unique identifier for client
    <i>Unik id forvaltningsklient</i> */
  id?: string | null
  /** Client number
    <i>Klient Nr</i> */
  no?: number
  /** Client name
    <i>KlientNavn</i> */
  name?: string | null
  /** Company number (Organization number)
    <i>Organisasjonsnummer</i> */
  companyNumber?: string | null
  /** Country code
    <i>Landkode</i> */
  countryCode?: string | null
}
export type PersonNameModel = {
  id?: string | null
  name?: string | null
  phoneNumber?: string | null
  email?: string | null
}
export type BblContactModel = {
  advisor?: PersonNameModel
  accountant?: PersonNameModel
}
export type UpdateElectronicCommunicationModel = {
  /** 0 = reserved against electronic communication, 1 = not reserved */
  acceptElectronicCommunication?: number
}
export enum SortOrder {
  $0 = 0,
  $1 = 1,
}
export enum PortalUserSortColumn {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
}
export enum PortalUserQueryRoles {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
}
export enum ContactRole {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
}
export enum ContactSortColumn {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
}
export enum ContactQueryRoles {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
}
export enum ExtendedQueryType {
  $0 = 0,
  $1 = 1,
  $2 = 2,
}
export enum OtherContactsSortColumn {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
}
export enum BoardContactsSortColumn {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
}
export enum ItemContactSortColumn {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
}
export enum TypeFilterOption {
  $0 = 0,
  $1 = 1,
}
export enum MinimizedClientsSortColumn {
  $0 = 0,
  $1 = 1,
}
export const {
  useGetClientsByIdQuery,
  useGetClientsQueryQuery,
  useGetClientsQuery,
  useGetClientsByIdDocumentsQuery,
  useGetClientsByIdDocumentsAndDocumentIdDownloadQuery,
  useGetClientsByIdPrivacystatementQuery,
  useGetClientsByIdSettingsQuery,
  usePostPortalusersMutation,
  useGetPortalusersSummaryQuery,
  usePutContactsAndNameIdMutation,
  useGetContactsAndNameIdUnitsQuery,
  usePostContactsQueryMutation,
  usePostOthercontactsQueryMutation,
  usePostBoardcontactsQueryMutation,
  useGetBoardcontactsAndIdQuery,
  usePutBoardcontactsAndIdMutation,
  useDeleteBoardcontactsAndIdMutation,
  usePostBoardcontactsMutation,
  usePostObjectcontactsQueryMutation,
  usePostMetercontactsQueryMutation,
  useGetObjecttypesQuery,
  useGetMetertypesQuery,
  useGetClientsByClientNoActiveinfoQuery,
  usePutClientsByIdAdvisorportalaccessMutation,
  useGetClientsByClientNoOwnersQuery,
  useGetMinimizedClientsQuery,
  useGetBblcontactsQuery,
  usePutContactsAndNameIdElectroniccommunicationMutation,
} = injectedRtkApi
